const Ajax = require('common/infra/ajax');

class API {
    getDiagrams(projectId, dt) {
        let path = `/api/projects/${projectId}/diagrams`;
        if(dt) {
            path += `?dt=${dt}`;
        }
        return Ajax.GET(path);
    }

    getDiagramsNotInDirectory(projectId, dt) {
        let path = `/api/projects/${projectId}/diagrams/nodirectory`;
        if(dt) {
            path += `?dt=${dt}`;
        }
        return Ajax.GET(path);
    }

    getDiagramsInDirectory(projectId, directoryId, dt) {
        let path = `/api/projects/${projectId}/diagram-directories/${directoryId}/diagrams`;
        if(dt) {
            path += `?dt=${dt}`;
        }
        return Ajax.GET(path);
    }

    getDiagram(projectId, diagramId, dt) {
        let path = `/api/projects/${projectId}/diagrams/${diagramId}`;
        if(dt) {
            path += `?dt=${dt}`;
        }
        return Ajax.GET(path);
    }

    createDiagram(projectId, diagramJson) {
        return Ajax.POST(`/api/projects/${projectId}/diagrams`, diagramJson);
    }

    updateDiagram(projectId, diagramId, diagramJson) {
        return Ajax.PUT(`/api/projects/${projectId}/diagrams/${diagramId}`, diagramJson);
    }

    deleteDiagram(projectId, diagramId) {
        return Ajax.DELETE(`/api/projects/${projectId}/diagrams/${diagramId}`);
    }

    getDiagramDirectories(projectId, dt) {
        let path = `/api/projects/${projectId}/diagram-directories`;
        if(dt) {
            path += `?dt=${dt}`;
        }
        return Ajax.GET(path);
    }

    createDiagramDirectory(projectId, diagramDirectoryJson) {
        return Ajax.POST(`/api/projects/${projectId}/diagram-directories`, diagramDirectoryJson);
    }

    updateDiagramDirectory(projectId, diagramDirectoryId, diagramDirectoryJson) {
        return Ajax.PUT(`/api/projects/${projectId}/diagram-directories/${diagramDirectoryId}`, diagramDirectoryJson);
    }

    deleteDiagramDirectory(projectId, diagramDirectoryId) {
        return Ajax.DELETE(`/api/projects/${projectId}/diagram-directories/${diagramDirectoryId}`);
    }

    /**
     * Comment を作成する
     *
     * @param projectID
     * @param diagramID
     * @param commentJSON
     * @returns {*}
     */
    createComment(projectID, diagramID, commentJSON) {
        return Ajax.POST(`/api/projects/${projectID}/diagrams/${diagramID}/comments`, commentJSON);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./system/infra/api/diagram.js